import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'
import { rem } from 'polished'
import styled from 'styled-components'
import SponsoredTileLogo from 'sponsoredSearch/SponsoredTileLogo'
import { _searchTileContainerQueryUp } from '../_SearchTileBase'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(16)};

  ${_searchTileContainerQueryUp.desktop} {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    gap: ${rem(20)};
  }
`

const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(4)};
  min-width: 0;
  order: 1;

  ${_searchTileContainerQueryUp.desktop} {
    order: 0;
    max-width: ${rem(340)};
  }
`

const Logo = styled(SponsoredTileLogo)`
  order: 0;

  ${_searchTileContainerQueryUp.desktop} {
    order: 1;
    flex-shrink: 0;
  }
`

interface Props {
  title: string
  body: string
  logo?: App.Image
}

function _SponsoredTileContentPrimary({ title, body, logo }: Props) {
  return <Container className={_SponsoredTileContentPrimary.name}>
    <Header>
      <Heading variant="heading5" lineClamp={2}>{title}</Heading>
      <BodyText variant="medium">{body}</BodyText>
    </Header>
    {logo && <Logo image={logo} />}
  </Container>
}

export default _SponsoredTileContentPrimary
